import { render, staticRenderFns } from "./ComForm.vue?vue&type=template&id=18d63502&scoped=true&"
import script from "./ComForm.vue?vue&type=script&lang=js&"
export * from "./ComForm.vue?vue&type=script&lang=js&"
import style0 from "./ComForm.vue?vue&type=style&index=0&id=18d63502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d63502",
  null
  
)

export default component.exports